import React from 'react'
import { Container, makeStyles } from '@material-ui/core'
import homeImage from '../../images/home.jpg'
import homeImgMobile from '../../images/homeMobile.jpg'
import HomeContent from './HomeContent'

const useStyles = makeStyles(() => ({
    container: {
        maxWidth: '100%',
        height: '90%',
        paddingRight: '0px',
        paddingLeft: '0px',
    },
    homeImg: {
        padding: '0px',
        margin: '0px',
        maxWidth: '100%',
        opacity: '0.9',
    },
    imgContainer: {
        maxWidth: '100%',
        margin: '0px',
        padding: '0px',
        marginTop: '50px',
        position: 'relative',
        color: 'white',
        '@media (max-width: 650px)': {
            display: 'none'
        }
    },
    imgContainerMobile: {
        maxWidth: '100%',
        margin: '0px',
        padding: '0px',
        marginTop: '50px',
        position: 'relative',
        color: 'white',
        '@media (min-width: 650px)': {
            display: 'none'
        }
    },
    bottomLeft: {
        position: 'absolute',
        top: '80%',
        left: '16px',
        fontSize: '50px',
        fontFamily: 'Helvetica, sans-serif',  
    },
    bottomLeftMobile: {
        position: 'absolute',
        top: '80%',
        left: '16px',
        fontSize: '20px',
        fontFamily: 'Helvetica, sans-serif',  
    }
}))

export default function Home() {
    const {container, homeImg, imgContainer, imgContainerMobile, bottomLeft, bottomLeftMobile} = useStyles()

    return (
        <Container className={container}>
            <Container className={imgContainer}>
                <img src={homeImage} alt='Fates' className={homeImg}/>
                <div className={bottomLeft}>M A Serviços de Usinagem</div>
            </Container> 
            <Container className={imgContainerMobile}>
                <img src={homeImgMobile} alt='Fates' className={homeImg}/>
                <div className={bottomLeftMobile}>M A Serviços de Usinagem</div>
            </Container> 
            <HomeContent />
        </Container>
    )
}